<template>
  <div class="card">
    <slot />
    <div v-if="$slots.content" class="card__content" :class="contentClass">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AppCard",
  props: {
    loading: Boolean
  },
  computed: {
    contentClass() {
      return {
        "loading-opacity": this.loading
      };
    }
  }
};
</script>

<style lang="scss">
.card {
  background: colors("palette-1");
  color: colors(text-1);
  text-decoration: none;
  transition: $primary-transition;
  box-shadow: shadow(), shadow(), shadow();

  &:hover {
    text-decoration: none;
  }

  &-media {
    position: relative;
    border-radius: inherit;

    &__image {
      display: block;
      width: 100%;
      border-radius: inherit;
    }

    &_wrap {
      border-radius: inherit;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
  }

  /* &-media__wrap, */
  &__content {
    padding: 20px;
  }

  &__content {
    position: relative;
  }

  &__loading {
    top: 50%;
    left: 50%;
    transform: translate(-50%, calc(-50% - 40px));
    position: absolute;
  }
}
</style>
